import React from 'react';
import { css } from '@compiled/react';

const styles = css({ maskType: 'luminance' });
export const CreateWithRovoLogoSVG = (): JSX.Element => {
	return (
		<svg
			width="100"
			height="100"
			viewBox="0 0 100 100"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_681_82381)">
				<path
					d="M8.58938 45.4461C7.06708 40.1372 10.1367 34.5994 15.4456 33.0771L34.6709 27.5644C39.9798 26.0421 45.5175 29.1117 47.0399 34.4206L52.5526 53.6459C54.0749 58.9548 51.0053 64.4925 45.6964 66.0148L26.4711 71.5276C21.1622 73.0499 15.6244 69.9802 14.1021 64.6713L8.58938 45.4461Z"
					fill="#1868DB"
				/>
				<g clipPath="url(#clip1_681_82381)">
					<g clipPath="url(#clip2_681_82381)">
						<path
							d="M40.2144 50.708C33.4587 49.5404 31.6025 49.6087 29.1025 50.3256C26.1693 51.1667 24.0193 53.1036 22.7694 57.1734L22.5635 57.8391C22.3959 58.3868 22.3765 58.5708 22.4332 58.7686C22.4899 58.9665 22.6372 59.1027 23.0701 59.2284L27.5079 60.4896C27.7457 60.5642 27.9313 60.5823 28.098 60.5345C28.298 60.4772 28.4029 60.34 28.5178 59.9859L28.8531 58.8906C29.3798 57.205 30.0807 56.5044 31.1473 56.1985C32.0806 55.9309 33.2562 55.8793 34.812 56.147L39.2747 56.8658C39.7314 56.9489 40.1363 56.7257 40.204 56.2067L40.8981 51.5825C40.9657 51.0635 40.7473 50.805 40.2144 50.708ZM20.8442 48.4469C27.6 49.6144 29.4562 49.5461 31.9561 48.8293C34.8894 47.9882 37.0394 46.0512 38.2893 41.9814L38.4952 41.3157C38.6628 40.768 38.6822 40.584 38.6255 40.3862C38.5687 40.1883 38.4215 40.0521 37.9886 39.9264L33.5507 38.6652C33.3129 38.5907 33.1273 38.5725 32.9607 38.6203C32.7607 38.6776 32.6557 38.8148 32.5408 39.1689L32.2056 40.2643C31.6789 41.9498 30.978 42.6504 29.9113 42.9563C28.978 43.2239 27.8024 43.2755 26.2467 43.0079L21.784 42.2891C21.3273 42.2059 20.9223 42.4291 20.8547 42.9481L20.1606 47.5723C20.093 48.0913 20.3114 48.3498 20.8442 48.4469Z"
							fill="white"
						/>
					</g>
				</g>
			</g>
			<mask
				id="mask0_681_82381"
				css={styles}
				maskUnits="userSpaceOnUse"
				x="43"
				y="31"
				width="42"
				height="41"
			>
				<path
					d="M82.564 60.9541C83.1722 59.6758 83.6876 58.2739 84.0999 56.7586C84.5123 55.2432 84.7906 53.7279 84.9143 52.3053C85.6668 43.7802 81.3888 37.2343 73.8224 33.7913C72.5338 33.2037 71.1422 32.7089 69.6784 32.3069C68.2146 31.9048 66.6374 31.6059 65.1632 31.4616C56.8855 30.6266 49.8861 34.0902 46.2266 41.77C45.6081 43.0689 45.0823 44.4812 44.6597 46.0274C44.237 47.5737 43.9793 49.0066 43.8556 50.4291C43.1134 58.8924 47.3811 65.4383 54.9579 68.9226C56.298 69.5411 57.7411 70.0668 59.2771 70.4791C60.8131 70.8915 62.1944 71.1492 63.6067 71.3038C71.8844 72.1697 78.9044 68.6958 82.564 60.9747V60.9541Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_681_82381)">
				<path
					d="M138.911 -12.6332L3.87695 -19.0249L-1.88939 102.798L133.145 109.19L138.911 -12.6332Z"
					fill="#1868DB"
				/>
				<path
					d="M98.0775 -14.5657L3.86833 -19.0293L1.99219 20.6583C13.5274 35.1933 30.3714 44.9863 50.9162 49.419C55.019 50.3055 59.2764 50.9859 63.6678 51.4394C66.0387 51.6868 68.4612 51.8724 70.9146 51.9858C77.6152 52.3053 84.0683 52.0992 90.2636 51.3879C108.592 49.2953 124.488 42.7494 136.806 32.0904L138.93 -12.638L98.1084 -14.576L98.0775 -14.5657Z"
					fill="#FCA700"
				/>
				<path
					d="M98.0777 -14.5659C82.3263 -3.92757 71.1107 12.2877 66.1936 33.6468C64.905 39.234 64.0494 45.1717 63.6577 51.4495C63.6164 52.0887 63.5855 52.7278 63.5546 53.3772C63.2247 60.2736 63.4927 66.8092 64.3071 72.9942C65.9874 85.7561 70.0077 96.9718 76.0175 106.497L133.137 109.208L136.786 32.1109L138.91 -12.6176L98.088 -14.5556L98.0777 -14.5659Z"
					fill="#6A9A23"
				/>
				<path
					d="M90.2432 51.398C126.56 47.2437 153.321 25.6577 161.66 -10.9167C162.939 -16.5142 163.784 -22.4622 164.165 -28.7607C162.042 -28.9669 159.887 -29.1318 157.712 -29.2349C150.723 -29.5648 144.002 -29.3277 137.569 -28.5649C101.284 -24.2662 74.595 -2.77306 66.2039 33.6468C64.9153 39.234 64.0597 45.1717 63.668 51.4495C66.0389 51.6969 68.4614 51.8825 70.9148 51.9959C77.6153 52.3154 84.0684 52.1093 90.2638 51.398H90.2432Z"
					fill="#AF59E1"
				/>
			</g>
			<path
				d="M52.8445 57.6143C52.7621 58.2637 52.628 58.8925 52.4219 59.5007C52.6177 58.8925 52.7621 58.2637 52.8445 57.6143Z"
				fill="#1868DB"
			/>
			<path
				d="M52.525 53.656C52.8136 54.6559 52.9373 55.6558 52.9167 56.6351C52.9373 55.6558 52.8136 54.6456 52.525 53.656Z"
				fill="#1868DB"
			/>
			<path
				d="M52.5256 53.656L48.1754 38.4922C47.4538 39.4818 46.794 40.5642 46.2271 41.7497C45.6704 42.9248 45.1962 44.2134 44.7942 45.5947C44.753 45.7391 44.7014 45.8627 44.6602 46.0071C44.2478 47.5224 43.9798 48.9862 43.8561 50.4088C43.5159 54.3054 44.2478 57.7897 45.8663 60.7585C46.6188 62.1398 47.5569 63.4078 48.6805 64.552C50.4535 63.2944 51.7524 61.511 52.4122 59.4906C52.608 58.8824 52.7523 58.2535 52.8348 57.6041C52.876 57.2845 52.8967 56.9547 52.907 56.6248C52.9276 55.6455 52.8039 54.6353 52.5152 53.6456L52.5256 53.656Z"
				fill="#101214"
			/>
			<path
				d="M51.0205 50.8105L77.7607 51.9032"
				stroke="white"
				strokeWidth="4.40172"
				strokeMiterlimit="10"
			/>
			<path
				d="M64.9364 37.9766L63.8438 64.7167"
				stroke="white"
				strokeWidth="4.40172"
				strokeMiterlimit="10"
			/>
			<defs>
				<clipPath id="clip0_681_82381">
					<path
						d="M8.58938 45.4461C7.06708 40.1372 10.1367 34.5994 15.4456 33.0771L34.6709 27.5644C39.9798 26.0421 45.5175 29.1117 47.0399 34.4206L52.5526 53.6459C54.0749 58.9548 51.0053 64.4925 45.6964 66.0148L26.4711 71.5276C21.1622 73.0499 15.6244 69.9802 14.1021 64.6713L8.58938 45.4461Z"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip1_681_82381">
					<rect
						width="30"
						height="30"
						fill="white"
						transform="translate(11.8174 39.3188) rotate(-16)"
					/>
				</clipPath>
				<clipPath id="clip2_681_82381">
					<rect
						width="20.6319"
						height="19.725"
						fill="white"
						transform="translate(17.8945 42.9404) rotate(-16)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
